(function(){
  var app = document.getElementById('pix-checkout-app');
  if (!app) return;
  var WEBHOOK = app.dataset.webhookUrl;
  var FRETE_WEBHOOK = 'https://primary-production-5d399.up.railway.app/webhook/calcular-frete';
  var PIX_KEY = 'reidamodaljt@gmail.com';
  var cart = null, comprovante = null, freteSelecionado = null;

  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
    cart = c;
    render();
  }).catch(function(){
    app.innerHTML = '<p style="color:red;text-align:center">Carrinho vazio. <a href="/collections/all">Continuar comprando</a></p>';
  });

  function formatMoney(cents){
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  // Mostra "Grátis" quando o valor é zero; senão o valor formatado.
  function formatFreteCents(cents){
    return cents === 0 ? '🎉 Grátis' : formatMoney(cents);
  }

  function render(){
    if (!cart || cart.item_count === 0){
      app.innerHTML = '<div class="pix-card" style="text-align:center"><p>Seu carrinho está vazio.</p><a href="/collections/all" style="color:#33bb33;font-weight:600">Continuar comprando</a></div>';
      return;
    }
    var items = cart.items.map(function(it){
      return '<div class="order-item">' +
        '<div class="item-info"><div class="item-title">' + escHtml(it.title) + '</div>' +
        '<div class="item-qty">Qtd: ' + it.quantity + '</div></div>' +
        '<div class="item-price">' + formatMoney(it.final_line_price) + '</div></div>';
    }).join('');

    // Banner condicional pra atacado (6+ peças): anuncia frete grátis Sudeste
    var atacadoBanner = '';
    if (cart.item_count >= 6){
      atacadoBanner = '<div style="background:linear-gradient(135deg,#e8f5e9,#f0fff4);border:2px solid #00a859;border-radius:10px;padding:14px 18px;text-align:center;margin-bottom:20px;color:#003a2b;font-size:1rem;font-weight:600;line-height:1.4">🎉 <strong>Frete grátis</strong> pra todo Sudeste (SP, RJ, MG, ES)!</div>';
    }

    app.innerHTML =
      '<div class="loading-overlay" id="loadingOverlay"><div class="loading-spinner"></div><div class="loading-text">Processando pedido...</div></div>' +
      '<div id="mainContent">' +
      atacadoBanner +
      '<div class="pix-card"><h2>\ud83d\udc64 Seus Dados</h2>' +
      '<div class="customer-fields">' +
      '<input type="text" id="customerName" placeholder="Nome completo *" required />' +
      '<input type="email" id="customerEmail" placeholder="E-mail *" required />' +
      '<input type="tel" id="customerPhone" placeholder="WhatsApp/Telefone *" required />' +
      '<input type="text" id="customerCpf" placeholder="CPF *" required maxlength="14" oninput="pixFormatCpf(this)" />' +
      '</div></div>' +

      '<div class="pix-card"><h2>\ud83d\udccd Endere\u00e7o de Entrega</h2>' +
      '<div class="customer-fields">' +
      '<input type="text" id="customerCep" placeholder="CEP *" required maxlength="9" oninput="pixFormatCep(this)" />' +
'<input type="text" id="customerAddress" placeholder="Endere\u00e7o (rua/avenida) *" required />' +
'<input type="text" id="customerNumber" placeholder="N\u00famero *" required />' +
'<input type="text" id="customerNeighborhood" placeholder="Bairro *" required />' +
'<input type="text" id="customerComplement" placeholder="Complemento (opcional)" />' +
'<input type="text" id="customerCity" placeholder="Cidade *" required />' +
    '<div class="select-wrapper-pix">' +
      '<select id="customerState" required>' +
      '<option value="">Estado *</option>' +
      '<option value="AC">AC</option><option value="AL">AL</option><option value="AP">AP</option>' +
      '<option value="AM">AM</option><option value="BA">BA</option><option value="CE">CE</option>' +
      '<option value="DF">DF</option><option value="ES">ES</option><option value="GO">GO</option>' +
      '<option value="MA">MA</option><option value="MT">MT</option><option value="MS">MS</option>' +
      '<option value="MG">MG</option><option value="PA">PA</option><option value="PB">PB</option>' +
      '<option value="PR">PR</option><option value="PE">PE</option><option value="PI">PI</option>' +
      '<option value="RJ">RJ</option><option value="RN">RN</option><option value="RS">RS</option>' +
      '<option value="RO">RO</option><option value="RR">RR</option><option value="SC">SC</option>' +
      '<option value="SP">SP</option><option value="SE">SE</option><option value="TO">TO</option>' +
      '</select></div>' +
      '</div>' +
      '<div class="frete-status" id="freteStatus" style="display:none"></div>' +
      '<div class="frete-opcoes" id="freteOpcoes"></div>' +
      '</div>' +

      '<div class="pix-card"><h2>\ud83d\udccb Resumo do Pedido</h2>' + items +
      '<div class="order-subtotal"><span class="label">Subtotal</span><span class="value">' + formatMoney(cart.total_price) + '</span></div>' +
      '<div class="order-frete" id="orderFreteLine" style="display:none"><span class="label">Frete</span><span class="value" id="orderFreteValue">\u2014</span></div>' +
      '<div class="order-total"><span class="label">Total a pagar</span><span class="value" id="orderTotalValue">' + formatMoney(cart.total_price) + '</span></div></div>' +

      '<div class="pix-card"><h2>\ud83d\udc9a Pagamento via PIX</h2>' +
      '<div class="pix-key-box">' +
      '<div class="pix-logo">\ud83c\udfe6</div>' +
      '<div class="pix-label">Chave PIX (E-mail)</div>' +
      '<div class="pix-key">' + PIX_KEY + '</div>' +
      '<button class="pix-copy-btn" onclick="pixCopyKey()">\ud83d\udccb Copiar Chave</button>' +
      '<div class="pix-holder"><span class="pix-holder-label">Titular:</span> Jackson Douglas</div>' +
      '<div class="pix-holder"><span class="pix-holder-label">Banco:</span> Pag Seguro</div>' +
      '</div>' +
      '</div>' +

      '<div class="pix-card"><h2>\ud83d\udcce Comprovante PIX</h2>' +
      '<p style="color:#555;font-size:.95rem;margin:0 0 16px">Ap\u00f3s realizar o PIX no seu banco, fa\u00e7a o upload do comprovante aqui.</p>' +
      '<div class="upload-area" id="uploadArea">' +
      '<div class="upload-icon">\ud83d\udce4</div>' +
      '<p><strong>Clique para enviar</strong> ou arraste o comprovante aqui</p>' +
      '<p style="font-size:.8rem">JPG, PNG ou PDF \u2014 m\u00e1x. 10MB</p>' +
      '<input type="file" id="pixFile" accept="image/*,.pdf" onchange="pixHandleFile(event)" />' +
      '</div>' +
      '<div class="upload-preview" id="uploadPreview"><img id="previewImg" src="" alt="Comprovante" /><p>\u2705 Comprovante selecionado!</p></div>' +
      '<div class="error-msg" id="errorMsg"></div></div>' +
      '<button class="submit-btn" id="submitBtn" onclick="pixSubmitOrder()">\u2705 Confirmar Pedido com PIX</button>' +
      '<div class="success-screen" id="successScreen"><div class="check">\ud83c\udf89</div><h2>Pedido Confirmado!</h2><p>Seu pedido foi recebido e o comprovante PIX est\u00e1 sendo verificado automaticamente.<br><br>Voc\u00ea receber\u00e1 uma confirma\u00e7\u00e3o em breve. <strong>Obrigado pela compra!</strong></p></div>' +
      '</div>';

    // Drag and drop
    var uploadArea = document.getElementById('uploadArea');
    uploadArea.addEventListener('dragover', function(e){ e.preventDefault(); uploadArea.classList.add('dragover'); });
    uploadArea.addEventListener('dragleave', function(){ uploadArea.classList.remove('dragover'); });
    uploadArea.addEventListener('drop', function(e){
      e.preventDefault();
      uploadArea.classList.remove('dragover');
      var file = e.dataTransfer.files[0];
      if (file) processFile(file);
    });
  }

  window.pixCopyKey = function(){
    navigator.clipboard.writeText(PIX_KEY).then(function(){
      var btn = document.querySelector('.pix-copy-btn');
      btn.textContent = '\u2705 Copiado!';
      btn.classList.add('copied');
      setTimeout(function(){ btn.textContent = '\ud83d\udccb Copiar Chave'; btn.classList.remove('copied'); }, 2000);
    });
  };

  window.pixCalcularFrete = function(){
    var cep = document.getElementById('customerCep').value.trim();
    if (cep.replace(/\D/g,'').length !== 8){ return; }
    hideError();

    var status = document.getElementById('freteStatus');
    var box = document.getElementById('freteOpcoes');
    // limpa frete anterior
    freteSelecionado = null;
    document.getElementById('orderFreteLine').style.display = 'none';
    document.getElementById('orderTotalValue').textContent = formatMoney(cart.total_price);
    box.innerHTML = '';
    status.style.display = 'block';
    status.style.color = '#666';
    status.textContent = '⏳ Calculando frete...';

    var payload = {
      cep: cep,
      valor: (cart.total_price / 100).toFixed(2),
      quantidade: cart.item_count
    };

    fetch(FRETE_WEBHOOK, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
    .then(function(r){ return r.json(); })
    .then(function(d){
      var opcoes = (d && d.opcoes) || [];
      if (!opcoes.length){
        status.style.display = 'none';
        box.innerHTML = '<p style="color:#c62828;font-size:.9rem">Nenhuma opção de frete encontrada para este CEP. Verifique o CEP digitado.</p>';
        return;
      }
      status.style.display = 'none';
      var html = '<p class="frete-titulo">Escolha o frete:</p>';
      opcoes.forEach(function(op, i){
        html += '<label class="frete-opcao" for="frete-' + i + '">' +
          '<input type="radio" name="freteRadio" id="frete-' + i + '" value="' + i + '" onchange="pixSelecionarFrete(' + i + ')">' +
          '<span class="frete-nome">' + escHtml(op.nome) + '</span>' +
          '<span class="frete-prazo">' + escHtml(op.prazo_texto || '') + '</span>' +
          '<span class="frete-preco">' + formatFreteCents(Math.round(op.preco * 100)) + '</span>' +
          '</label>';
      });
      box.innerHTML = html;
      window._freteOpcoes = opcoes;
    })
    .catch(function(){
      status.style.display = 'none';
      box.innerHTML = '<p style="color:#c62828;font-size:.9rem">Erro ao calcular o frete. Tente novamente.</p>';
    });
  };

  window.pixSelecionarFrete = function(i){
    var op = (window._freteOpcoes || [])[i];
    if (!op) return;
    freteSelecionado = op;
    var freteCents = Math.round(op.preco * 100);
    document.getElementById('orderFreteLine').style.display = 'flex';
    document.getElementById('orderFreteValue').textContent = formatFreteCents(freteCents);
    document.getElementById('orderTotalValue').textContent = formatMoney(cart.total_price + freteCents);
  };

  window.pixFormatCpf = function(el){
    var v = el.value.replace(/\D/g, '').substring(0, 11);
    if (v.length > 9) v = v.replace(/(\d{3})(\d{3})(\d{3})(\d{1,2})/, '$1.$2.$3-$4');
    else if (v.length > 6) v = v.replace(/(\d{3})(\d{3})(\d{1,3})/, '$1.$2.$3');
    else if (v.length > 3) v = v.replace(/(\d{3})(\d{1,3})/, '$1.$2');
    el.value = v;
  };

  window.pixFormatCep = function(el){
    var v = el.value.replace(/\D/g, '');
    if (v.length > 5) v = v.substring(0,5) + '-' + v.substring(5,8);
    el.value = v;
    if (v.replace('-','').length === 8){
      fetch('https://viacep.com.br/ws/' + v.replace('-','') + '/json/')
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (!d.erro){
          document.getElementById('customerAddress').value = d.logradouro || '';
document.getElementById('customerNeighborhood').value = d.bairro || '';
document.getElementById('customerCity').value = d.localidade || '';
          var stateSelect = document.getElementById('customerState');
          for (var i = 0; i < stateSelect.options.length; i++){
            if (stateSelect.options[i].value === d.uf){
              stateSelect.selectedIndex = i;
              break;
            }
          }
        }
      })
      .catch(function(){})
      .finally(function(){ window.pixCalcularFrete(); });
    }
  };

  window.pixHandleFile = function(e){
    var file = e.target.files[0];
    if (file) processFile(file);
  };

  function processFile(file){
    if (file.size > 10 * 1024 * 1024){ showError('Arquivo muito grande. M\u00e1x. 10MB.'); return; }
    hideError();

    var preview = document.getElementById('uploadPreview');
    var img = document.getElementById('previewImg');
    preview.style.display = 'block';

    // PDF passa direto sem reprocessar
    if (file.type === 'application/pdf'){
      var pdfReader = new FileReader();
      pdfReader.onload = function(ev){
        comprovante = ev.target.result;
        img.style.display = 'none';
      };
      pdfReader.onerror = function(){
        showError('Erro ao ler o PDF.');
        preview.style.display = 'none';
      };
      pdfReader.readAsDataURL(file);
      return;
    }

    // Imagem: reprocessa via canvas pra garantir JPEG RGB 8-bit padrão (compatível com Meta WhatsApp)
    var imgReader = new FileReader();
    imgReader.onload = function(ev){
      var image = new Image();
      image.onload = function(){
        var maxDim = 2000;
        var w = image.naturalWidth || image.width;
        var h = image.naturalHeight || image.height;
        if (w > maxDim || h > maxDim){
          if (w > h){ h = Math.round(h * maxDim / w); w = maxDim; }
          else { w = Math.round(w * maxDim / h); h = maxDim; }
        }
        try {
          var canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#FFFFFF';
          ctx.fillRect(0, 0, w, h);
          ctx.drawImage(image, 0, 0, w, h);
          comprovante = canvas.toDataURL('image/jpeg', 0.9);
          img.src = comprovante;
          img.style.display = 'block';
        } catch (err){
          showError('N\u00e3o foi poss\u00edvel processar a imagem. Tente outra foto ou envie em PDF.');
          preview.style.display = 'none';
        }
      };
      image.onerror = function(){
        showError('Formato de imagem n\u00e3o suportado. Use JPG ou PNG, ou envie em PDF.');
        preview.style.display = 'none';
      };
      image.src = ev.target.result;
    };
    imgReader.onerror = function(){
      showError('Erro ao ler o arquivo.');
      preview.style.display = 'none';
    };
    imgReader.readAsDataURL(file);
  }

  window.pixSubmitOrder = function(){
    var name = document.getElementById('customerName').value.trim();
    var email = document.getElementById('customerEmail').value.trim();
    var phone = document.getElementById('customerPhone').value.trim();
    var cpf = document.getElementById('customerCpf').value.trim();
    var cep = document.getElementById('customerCep').value.trim();
var address = document.getElementById('customerAddress').value.trim();
var number = document.getElementById('customerNumber').value.trim();
var neighborhood = document.getElementById('customerNeighborhood').value.trim();
var complement = document.getElementById('customerComplement').value.trim();
var city = document.getElementById('customerCity').value.trim();
    var state = document.getElementById('customerState').value;

    if (!name || !email || !phone){ showError('Por favor, preencha nome, e-mail e telefone.'); return; }
    if (!cpf || cpf.replace(/\D/g,'').length !== 11){ showError('Por favor, preencha um CPF v\u00e1lido (11 d\u00edgitos).'); return; }
   
    if (!freteSelecionado){ showError('Por favor, calcule e selecione uma op\u00e7\u00e3o de frete.'); return; }
    if (!comprovante){ showError('Por favor, anexe o comprovante PIX.'); return; }
    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRe.test(email)){ showError('E-mail inv\u00e1lido.'); return; }
    hideError();
    setLoading(true);

    var lineItems = cart.items.map(function(it){
      return { variant_id: it.variant_id, quantity: it.quantity, price: (it.final_price / 100).toFixed(2), title: it.title };
    });

    var freteCents = Math.round(freteSelecionado.preco * 100);
    var totalComFrete = cart.total_price + freteCents;

    var payload = {
      customer_name: name,
      customer_email: email,
      customer_phone: phone,
      customer_cpf: cpf,
shipping_address: {
  zip: cep,
  address1: address + ', ' + number,
  address2: 'Bairro: ' + neighborhood + (complement ? ' - ' + complement : ''),
  number: number,
  neighborhood: neighborhood,
  complement: complement,
  city: city,
  province: state,
  country: 'BR'
},
      items: lineItems,
      frete: {
        id: freteSelecionado.id,
        nome: freteSelecionado.nome,
        preco: (freteSelecionado.preco).toFixed(2),
        prazo: freteSelecionado.prazo_texto || ''
      },
      subtotal: (cart.total_price / 100).toFixed(2),
      total: (totalComFrete / 100).toFixed(2),
      comprovante_base64: comprovante
    };

    fetch(WEBHOOK, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
    .then(function(r){
      if (!r.ok) throw new Error('Erro ' + r.status);
      fetch('/cart/clear.js', { method: 'POST' }).catch(function(){});
      setLoading(false);
      window.location.href = '/pages/obrigado';
    })
    .catch(function(err){
      setLoading(false);
      showError('Erro ao enviar pedido: ' + err.message + '. Tente novamente.');
    });
  };

  function setLoading(v){
    document.getElementById('loadingOverlay').classList.toggle('show', v);
    var btn = document.getElementById('submitBtn');
    if (btn) btn.disabled = v;
  }

  function showError(msg){
    var el = document.getElementById('errorMsg');
    if (el){ el.textContent = msg; el.style.display = 'block'; }
  }

  function hideError(){
    var el = document.getElementById('errorMsg');
    if (el) el.style.display = 'none';
  }

  function escHtml(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }
})();
